import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ExampleNg6LibService {

  constructor() { }

  public test() {
    alert('wqdw qd qwd ')
  }
}
